"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderType = exports.useTokenDisplay = void 0;
var react_1 = require("react");
var context_1 = require("../../context/context");
var useSwapModal_1 = require("../../hooks/useSwapModal");
var hooks_1 = require("../../hooks/hooks");
var lib_1 = require("../../hooks/lib");
var useTokenDisplay = function (isSrc) {
    var _a = (0, useSwapModal_1.useSwapModal)(), outAmount = _a.outAmount, srcAmount = _a.srcAmount, srcToken = _a.srcToken, dstToken = _a.dstToken, srcUsd = _a.srcUsd, dstUsd = _a.dstUsd;
    var token = isSrc ? srcToken : dstToken;
    var amount = (0, hooks_1.useFormatNumberV2)({ value: isSrc ? srcAmount : outAmount, decimalScale: 3 });
    var usd = (0, hooks_1.useFormatNumberV2)({ value: isSrc ? srcUsd : dstUsd, decimalScale: 2 });
    var title = isSrc ? "From" : "To";
    return {
        token: token,
        amount: amount,
        usd: usd,
        title: title,
    };
};
exports.useTokenDisplay = useTokenDisplay;
var useOrderType = function () {
    var _a = (0, context_1.useTwapContext)(), isLimitPanel = _a.isLimitPanel, t = _a.translations;
    var isMarketOrder = (0, lib_1.useIsMarketOrder)();
    return (0, react_1.useMemo)(function () {
        if (isLimitPanel) {
            return t.limit;
        }
        if (isMarketOrder) {
            return t.twapMarket;
        }
        return t.twapLimit;
    }, [isLimitPanel, isMarketOrder, t]);
};
exports.useOrderType = useOrderType;
